import React from "react";
import { isoToDisplay } from "./DateInput";
import { namaGelar } from "../lib/utils";

const nama = (fam, id) => namaGelar(fam.anggota?.find((x) => x.id === id)) || "-";

export const KartuKeluargaPrint = ({ fam, nonJemaat = [] }) => (
  <div className="hidden print-kk" data-testid="kk-print-area">
    <div style={{ textAlign: "center", borderBottom: "2px solid #000", paddingBottom: 6, marginBottom: 10 }}>
      <div style={{ fontSize: 16, fontWeight: 700, letterSpacing: 1 }}>KARTU KELUARGA JEMAAT</div>
      <div style={{ fontSize: 12 }}>GKPY · Sistem Informasi Administrasi & Pelayanan</div>
    </div>
    <table style={{ marginBottom: 10 }}>
      <tbody>
        <tr><th style={{ width: "22%" }}>Nama Keluarga</th><td>{fam.nama_keluarga}</td><th style={{ width: "18%" }}>No. KK</th><td>{fam.nomor_kk || "-"}</td></tr>
        <tr><th>Kepala Keluarga</th><td>{namaGelar(fam.kepala_keluarga) || "-"}</td><th>Satu Atap</th><td>{fam.household?.nama || "-"}</td></tr>
        <tr><th>Alamat</th><td colSpan={3}>{fam.alamat || "-"}</td></tr>
      </tbody>
    </table>
    <table>
      <thead><tr><th style={{ width: 28 }}>No</th><th>Nama Lengkap</th><th>NIJ</th><th>Hubungan</th><th>Status</th><th>Relasi dalam KK</th></tr></thead>
      <tbody>
        {(fam.anggota || []).map((a, i) => (
          <tr key={a.id}>
            <td>{i + 1}</td><td>{namaGelar(a)}</td><td style={{ fontFamily: "monospace" }}>{a.nij}</td><td>{a.hubungan_keluarga || "-"}</td><td>{a.status_jemaat || "-"}</td>
            <td>{[a.ayah_dalam_kk && `Ayah: ${a.sensitif_disamarkan ? "****" : nama(fam, a.ayah_id)}`, a.ibu_dalam_kk && `Ibu: ${a.sensitif_disamarkan ? "****" : nama(fam, a.ibu_id)}`,
              a.anak_dalam_kk?.length > 0 && `Anak: ${a.anak_dalam_kk.map((c) => nama(fam, c)).join(", ")}`].filter(Boolean).join(" · ") || "-"}</td>
          </tr>
        ))}
        {nonJemaat.map((n, i) => (
          <tr key={n.id} style={{ background: "#f1f5f9" }} data-testid={`kk-print-non-${n.id}`}>
            <td>{(fam.anggota?.length || 0) + i + 1}</td><td>{n.nama_lengkap} *</td><td style={{ fontFamily: "monospace" }}>NON-JEMAAT</td><td>{n.hubungan_keluarga || "-"}</td><td>Non-Jemaat</td><td>{n.agama ? `Agama: ${n.agama}` : "-"}</td>
          </tr>
        ))}
      </tbody>
    </table>
    {nonJemaat.length > 0 && <div style={{ marginTop: 6, fontSize: 9, color: "#475569", fontStyle: "italic" }}>* Anggota keluarga Non-Jemaat ({nonJemaat.length} orang) — tercatat di Kartu Keluarga, bukan jemaat terdaftar dan tidak masuk Direktori Jemaat.</div>}
    <div style={{ marginTop: 12, fontSize: 10, color: "#475569" }}>Jumlah anggota: {fam.anggota?.length || 0} jemaat{nonJemaat.length > 0 ? ` + ${nonJemaat.length} non-jemaat` : ""} · Dicetak: {isoToDisplay(new Date().toISOString().slice(0, 10))}</div>
  </div>
);
